import { DefaultSecondaryButton, Squircle } from '@frontend/components/common';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { useActiveModal, useModals } from '@frontend/modal';
import { TELLOPORT_RADIUS } from '@frontend/repository';
import React from 'react';

interface BasicModalprops {
    title: React.ReactNode;
    children?: React.ReactNode;
    close?: {
        onClose?: () => void;
        text?: React.ReactNode;
    };
}
export const BasicModal = (props: BasicModalprops) => {
    const { modalId } = useActiveModal();
    const { closeModal } = useModals();

    const close = () => {
        if (props.close) {
            props.close.onClose && props.close.onClose();
        }
        closeModal(modalId);
    };
    return (
        <div style={{ filter: 'drop-shadow(0 0 0 1px var(--color-border-default))' }}>
            <Squircle
                cornerRadius={TELLOPORT_RADIUS.lg}
                className='bg-background-surface inline-flex max-w-96 flex-col items-center justify-center gap-6 overflow-hidden p-6'>
                <div className='inline-flex flex-col items-start justify-start gap-6 self-stretch'>
                    <div className='flex w-full flex-row items-center justify-between'>
                        <div className='text-foreground-default justify-start text-xl font-semibold'>{props.title}</div>
                        <ICONS.BUTTON.CLOSE
                            onClick={close}
                            className='text-foreground-default h-6 w-6'
                        />
                    </div>
                    {props.children}
                </div>
                <div className='flex w-full justify-end'>
                    <DefaultSecondaryButton
                        onClick={close}
                        text={props.close?.text || CommonMessage.BUTTONS.CLOSE}
                    />
                </div>
            </Squircle>
        </div>
    );
};
